export const FORM_INSTANCE_STATUS = {
  NOT_STARTED: 0,
  IN_PROGRESS: 1,
  COMPLETED: 2,
} as const;

export type FormInstanceStatus =
  (typeof FORM_INSTANCE_STATUS)[keyof typeof FORM_INSTANCE_STATUS];

export const QUESTION_TYPE = {
  TEXT_INPUT: 0,
  SINGLE_SELECT: 1,
  MULTI_DOC_UPLOAD: 2,
  READ_ONLY: 3,
} as const;

export type QuestionType = (typeof QUESTION_TYPE)[keyof typeof QUESTION_TYPE];

export const ACTOR_TYPE = {
  CUSTOMER: 0,
  ADMIN: 1,
} as const;

export type ActorType = (typeof ACTOR_TYPE)[keyof typeof ACTOR_TYPE];

export const INCORPORATION_TRACKER_FILTER = {
  NOT_ASSIGNED: 0,
  DRAFT: 1,
  PUBLISHED: 2,
  COMPLETED: 3,
} as const;

export type IncorporationTrackerFilter =
  (typeof INCORPORATION_TRACKER_FILTER)[keyof typeof INCORPORATION_TRACKER_FILTER];

export const CREATE_NEW_TEMPLATE_VALUE = "CREATE_NEW_TEMPLATE";

export const INCORPORATION_FORM_MODE = {
  EDIT: "edit",
  VIEW: "view",
} as const;

export type IncorporationFormMode =
  (typeof INCORPORATION_FORM_MODE)[keyof typeof INCORPORATION_FORM_MODE];

export const INCORPORATION_FORM_SOURCE = {
  INSTANCE: "instance",
  TEMPLATE: "template",
} as const;

export type IncorporationFormSource =
  (typeof INCORPORATION_FORM_SOURCE)[keyof typeof INCORPORATION_FORM_SOURCE];

export const PENDING_ANSWER_TYPE = {
  TEXT: "text",
  OPTION: "option",
  UPLOAD: "upload",
  DELETE: "delete",
} as const;

export type PendingAnswerType =
  (typeof PENDING_ANSWER_TYPE)[keyof typeof PENDING_ANSWER_TYPE];
